import {ElementRef, InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export enum ScrollingAxis {
    X = 0,
    Y = 1
}

export interface Scrollbar {
    isEnabled: boolean;
    onScrollEvent: Observable<any>;
    scrollTo(childElementRef: ElementRef): void;
    getScrollingPosOnAxis(axis: ScrollingAxis): number;
    setScrollingPosOnAxis(axis: ScrollingAxis, posOnAxis: number): void;
}

export const SCROLLBAR = new InjectionToken<Scrollbar>('Scrollbar');
